import React, {useContext, useEffect, useRef, useState} from "react";
import "./form.scss";
import {useNavigate, useSearchParams} from "react-router-dom";
import "react-phone-number-input/style.css";
import useApi from "../../hooks/useApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {DEFAULT_ERROR, GET_TEST_VERIFY_URL, REGISTER_URL, SEND_COUNTRIES_URL} from "../../api/urls";
import AuthContext from "../../context/AuthProvider";
import {useParams} from "react-router";
import {Loading} from "../loading";
import {useDispatch, useSelector} from "react-redux";
import {fetchCountries} from "../../store/actions/examActions";
import SearchableDropdown from "../dropDown/SearchableDropdown";
import {PrimaryButton} from "../button";
import {selectState, setExamMeta} from "../../store/slices/examSlice";
import api from "../../api/axios";
import {useMediaQuery} from "react-responsive";
import {FIELD_CONFIG} from "../../pages/Channels/AdditionalFormModal";

const PROFILE_FIELD_CONFIG = {
  ...FIELD_CONFIG,
  stateOrigin: { label: "State of Origin", type: "text", placeholder: "e.g. Lagos" },
  phoneNo: { label: "Phone Number", type: "tel", placeholder: "e.g. 0800 000 0000" },
};

const BUSINESS_PROFILE_FIELD_ORDER = [
  "dob",
  "city",
  "stateOrigin",
  "phoneNo",
  "address",
  "principalName",
  "schoolContactNo",
  "schoolEmail",
  "schoolAddress",
  "schoolClass",
];

const NEW_BUSINESS_PROFILE_FIELDS = [
  "stateOrigin",
  "phoneNo",
  "principalName",
  "schoolContactNo",
  "schoolEmail",
  "schoolAddress",
  "schoolClass",
];

const SCHOOL_VERIFICATION_FIELDS = [
  "principalName",
  "schoolContactNo",
  "schoolEmail",
  "schoolAddress",
  "schoolClass",
];

function SignUpCompleteForm({handle}) {
  const useTabletAndBelowMediaQuery = () =>
      useMediaQuery({ query: '(max-width: 768px)' })
  const isTabletAndBelow = useTabletAndBelowMediaQuery();
  const { isLoggedIn, user, userUpdate} = useContext(AuthContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { examsdata } = useSelector((state) => state.exam);
  const {id} = useParams();
  const [loadingCountry, setLoadingCountry] = useState(true);
  const [countryFilter, setCountryFilter] = useState("");
  const [statesFilter, setStatesFilter] = useState("");
  const [notRegisteredFlag, setNotRegisteredFlag] = useState(false);
  const [channelName, setChannelName] = useState("");
  const states = useRef([]);
  const rowMetaRef = useRef(null);

  useEffect(() => {
    const stored = localStorage.getItem(`meta-rowData-${id}`);
    const parsed = stored ? JSON.parse(stored) : null;
    rowMetaRef.current = parsed;
    setNotRegisteredFlag(!!parsed?.notRegistered);
    setChannelName(parsed?.businessName || "");
    dispatch(fetchCountries({ businessId: parsed?.businessId }));
  }, [id]);

  useEffect(() => {
    if(examsdata.sendingloadingCountryDone) {
      setLoadingCountry(false);
      // console.log("i am here done");
    }
    // console.log("out side");
  },[examsdata.sendingloadingCountryDone]);


  const handleSchoolChange = (e) => {
    handleForm(e.target.name,e.target.value);
  }
  const handleForm = (name,value) => {
    setForm({
      ...form,
      [name]: value,
    });
  }
  const handleStateChange = (val) => {
    setStatesFilter(val);
    handleForm("state",val);
  }
  const handleCountryChange = (val,countryId) => {
    setCountryFilter(val);
    handleForm("country",val);
    dispatch(selectState({countryId: countryId}))
    // handleFilterChange(val,1);
    // console.log("i am called 3",val,countryId,form);
  };



  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState("");
  const api = useApi();

  const [form, setForm] = useState({
    state: "",
    country: "",
    schoolName: "",
  });

  const requestedFields = examsdata.requiredFields || [];
  const includedFields = requestedFields.length && rowMetaRef.current?.businessId
    ? Array.from(new Set([...requestedFields, ...NEW_BUSINESS_PROFILE_FIELDS]))
    : requestedFields;
  const requiredFields = [
    ...BUSINESS_PROFILE_FIELD_ORDER.filter((field) => includedFields.includes(field)),
    ...includedFields.filter((field) => !BUSINESS_PROFILE_FIELD_ORDER.includes(field)),
  ];
  const hasRequiredFields = requiredFields.length > 0;
  const hasCountries = (examsdata.countries || []).length > 0;
  const generalProfileFields = requiredFields.filter(
    (field) => !SCHOOL_VERIFICATION_FIELDS.includes(field)
  );
  const schoolVerificationFields = SCHOOL_VERIFICATION_FIELDS.filter(
    (field) => requiredFields.includes(field)
  );

  const handleExtraFieldChange = (field, val) => {
    handleForm(field, val);
  };

  async function handleContinue(e) {
    e.preventDefault();
    if (hasRequiredFields && requiredFields.some(
      (field) => !PROFILE_FIELD_CONFIG[field]?.optional && !(form[field] || "").trim()
    )) {
      toast.error("Please fill in all required fields");
      return;
    }
    if (hasCountries) {
      if (!form?.country) {
        toast.error("Country is required");
        return;
      } else if (!form?.state) {
        toast.error("State is required");
        return;
      } else if (!form.schoolName) {
        toast.error("School Name is required");
        return;
      }
    }
    setIsLoading(true);
    await sendProfileComplete();
  }


  const sendProfileComplete = async () => {
    try {
      const payload = {};
      if (hasRequiredFields) {
        requiredFields.forEach((field) => {
          if (!PROFILE_FIELD_CONFIG[field]?.optional || (form[field] || "").trim()) {
            payload[field] = form[field];
          }
        });
      }
      if (hasCountries) {
        payload.country = form.country;
        payload.state = form.state;
        payload.schoolName = form.schoolName;
      }
      if (rowMetaRef.current?.notRegistered) {
        payload.businessId = rowMetaRef.current?.businessId;
      }
      const response = await api.post(SEND_COUNTRIES_URL,payload);
      const serverUser = response.data?.user;
      if (serverUser) {
        const joined = response.data.channel || response.data.subscribed;
        const existing = Array.isArray(user.channels) ? user.channels : [];
        const merged = joined
          ? [...existing.filter((c) => (c.id || c._id) !== (joined.id || joined._id)), joined]
          : existing;
        userUpdate({ ...user, ...serverUser, channels: merged });
      }
      toast.success(
        "Your account has been updated."
      );
      window.scrollTo({top: 0, left: 0, behavior: 'instant'});
      fetchQuestion();
    } catch (error) {
      showErrorToast(error);
      setIsLoading(false);
    }
  };
  const getErrorMessages = (error) => {
    const data = error?.response?.data;
    if (Array.isArray(data?.errors) && data.errors.length) {
      return data.errors.filter(Boolean).map(String);
    }

    if (data?.errors && typeof data.errors === "object") {
      const messages = Object.values(data.errors).flat().filter(Boolean).map(String);
      if (messages.length) return messages;
    }

    if (typeof data === "string" && data.trim()) return [data];
    if (typeof data?.error === "string" && data.error.trim()) return [data.error];
    if (typeof data?.message === "string" && data.message.trim()) return [data.message];

    return [error?.response?.statusText || error?.message || DEFAULT_ERROR];
  };

  const showErrorToast = (error) => {
    const messages = getErrorMessages(error);
    toast.error(
      <div className="profile-error-list">
        {messages.map((message, index) => (
          <div key={`${message}-${index}`}>{message}</div>
        ))}
      </div>
    );
  };


  const formatMeta = (meta) => {
    const rowData = JSON.parse(localStorage.getItem(`meta-rowData-${id}`));
    localStorage.removeItem(`meta-rowData-${id}`);
    meta.subject = rowData.subject;
    meta.session = rowData.session;
    meta.duration = rowData.duration;
    meta.number = rowData.number;
    meta.examMarks = rowData.examMarks;
    const isContinue = rowData.continue === 1;
    return [meta,isContinue];
  };

  const fetchQuestion = async () => {
    try {
      const response = await api.get(`${GET_TEST_VERIFY_URL}/${id}`);
      const [meta,isContinue] = formatMeta(response.data.meta);
      dispatch(setExamMeta(meta));
      localStorage.setItem(`meta-${meta.uniqueId}`, JSON.stringify({ ...meta}));
      if(!isContinue) {
        navigate(`/test-instructions/${meta.uniqueId}`,{replace: true});
      }else{
        if(!isTabletAndBelow && meta.enable_fullscreen){
          handle.enter();
        }
        navigate(`/questions-dashboard/${meta.uniqueId}`,{replace: true});
      }
    } catch (error) {
      showErrorToast(error);
    }
    setIsLoading(false);
  };

  const getDobMaxDate = () => {
    const today = new Date();
    today.setFullYear(today.getFullYear() - 5);
    return today.toISOString().split("T")[0];
  };

  const renderProfileField = (field) => {
    const config = PROFILE_FIELD_CONFIG[field] || {
      label: field,
      type: "text",
      placeholder: "",
    };

    return (
      <div className={`form complete-profile-field ${field === "address" ? "complete-profile-field-wide" : ""}`} key={field}>
        <h6>
          {config.label}
          {config.optional ? <small> (Optional)</small> : <b> *</b>}
        </h6>
        <input
          type={config.type}
          name={field}
          placeholder={config.placeholder}
          value={form[field] || ""}
          onChange={(e) => handleExtraFieldChange(field, e.target.value)}
          max={field === "dob" ? getDobMaxDate() : undefined}
          required={!config.optional}
        />
      </div>
    );
  };

  return (
    <>
      <div className={`sign-complete auth-page ${hasRequiredFields ? "col-md-8 offset-md-2" : "col-md-4 offset-md-4"}`}>
        <div className="">
          {" "}
      <ToastContainer />
      <center className="logo-mar-btm">
        <div >
          <h5>Complete Your Profile to continue</h5>
        </div>
      </center>
      {loadingCountry?(
          <Loading size={70} style={{ padding: '64px 32px', minHeight: '50vh' }} />
      ):(
          <div className="">
            <form className=" form-container" action="" onSubmit={handleContinue}>
              {hasRequiredFields && (
                <div className="complete-profile-fields">
                  {generalProfileFields.map(renderProfileField)}

                  {schoolVerificationFields.length > 0 && (
                    <div className="complete-profile-group-header">
                      <strong>School verification</strong>
                      <span>
                        For verification purposes, the following information is required.
                      </span>
                    </div>
                  )}

                  {schoolVerificationFields.map(renderProfileField)}
                </div>
              )}

              {hasCountries && (
                <>
                  <div className="form" style={hasRequiredFields ? {marginTop: "2rem"} : undefined}>
                    <h6>Select Country <b>*</b></h6>
                    <SearchableDropdown
                        options={examsdata.countries}
                        label="name"
                        finalVal="id"
                        id="id"
                        selectedVal={countryFilter}
                        handleChange={handleCountryChange}
                    />
                  </div>
                  {examsdata.selectedStates.length?(
                      <div className="form" style={{marginTop: "2rem"}}>
                        <h6>Select State <b>*</b></h6>
                        <SearchableDropdown
                            options={examsdata.selectedStates}
                            label="name"
                            id="state"
                            selectedVal={statesFilter}
                            handleChange={handleStateChange}
                        />
                      </div>
                  ):(
                      <div className="form" style={{marginTop: "2rem"}}>
                        <h6>School State <b>*</b></h6>
                        <input disabled={!!!countryFilter} type="text" name="state" onChange={handleSchoolChange} />
                      </div>
                  )}

                  <div className="form" style={{marginTop: "2rem"}}>
                    <h6>School Name <b>*</b></h6>
                    <input type="text" name="schoolName" onChange={handleSchoolChange} />
                  </div>
                </>
              )}

              <PrimaryButton
                             isLoadingMsg="please wait..." size="sm" className={`${
                 "formButtonActive formbutton mb-5"
              }`} isLoading={isLoading}>Continue</PrimaryButton>
            </form>
          </div>
      )}
        </div>
      </div>
    </>
  );
}

export default SignUpCompleteForm;
